export default {"src":"/_next/static/media/logo-full.a0349044.svg","height":47,"width":212,"blurWidth":0,"blurHeight":0};